import React from 'react';
import {
  QrCode,
  Image,
  Lock,
  FileX,
  Shield,
  FileCode,
  Hash,
  MessageSquare,
  KeyRound,
  ShieldCheck,
} from 'lucide-react';

import ToolCard from '../components/ToolCard';

const Explore = () => {
  const tools = [
    {
      name: 'QR Code Studio',
      description:
        'Generate and scan password-protected QR codes with custom styling and embedded encryption.',
      icon: QrCode,
      path: '/tools/qr-code-studio',
      featured: true,
    },
    {
      name: 'Steganography Tool',
      description:
        'Hide sensitive data inside images using advanced steganography techniques. Decrypt with password.',
      icon: Image,
      path: '/tools/steganography',
      featured: true,
    },
    {
      name: 'Encryption Toolkit',
      description:
        'Encrypt and decrypt text, files, and JSON with military-grade encryption algorithms.',
      icon: Lock,
      path: '/tools/encryption',
      featured: true,
    },
    {
      name: 'Metadata Remover',
      description:
        'Strip all identifying metadata from images, PDFs, and documents to protect your privacy.',
      icon: FileX,
      path: '/tools/metadata-remover',
    },
    {
      name: 'Secure Text Vault',
      description:
        'Create ephemeral encrypted notes with self-destruction options. Export as files or QR codes.',
      icon: Shield,
      path: '/tools/secure-vault',
    },
    {
      name: 'File Encoder',
      description:
        'Convert files between formats with optional encryption. Text to image, file to Base64, and more.',
      icon: FileCode,
      path: '/tools/file-encoder',
    },
    {
      name: 'Hash Generator',
      description:
        'Generate and verify file hashes using SHA-256, SHA-512, and MD5 algorithms locally.',
      icon: Hash,
      path: '/tools/hash-generator',
    },
    {
      name: 'Password Generator',
      description:
        'Generate strong, random passwords with customizable length and character options.',
      icon: KeyRound,
      path: '/tools/password-generator',
    },
    {
      name: 'Password Strength Checker',
      description:
        'Analyze password strength in real time and get feedback to improve security.',
      icon: ShieldCheck,
      path: '/tools/password-strength',
    },
  ];

  return (
    <div className="py-20 animate-fade-in">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl lg:text-5xl font-bold mb-4">
            Explore <span className="gradient-text">Privacy Tools</span>
          </h1>
          <p className="text-muted-foreground text-lg leading-relaxed">
            Professional security tools that run entirely in your browser.
            No tracking, no storage, no compromises.
          </p>
        </div>

        {/* Tools Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tools.map((tool, index) => (
            <div
              key={tool.path}
              className="animate-fade-in-up"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <ToolCard tool={tool} />
            </div>
          ))}
        </div>

        {/* Bottom Info */}
        <div className="mt-16 text-center glass-card p-8 max-w-2xl mx-auto">
          <p className="text-muted-foreground leading-relaxed">
            All tools are open source and auditable. Your data is processed locally using
            Web Crypto API, Canvas API, and File API.
            <span className="block mt-2 font-semibold text-foreground">
              Nothing ever leaves your device.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Explore;
